import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContentDC';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';

export interface TextBlockProps {
  header?: BlockHeader;
  text: RichTextFieldStrapiProps;
}

export function TextBlockStrapi({
  block,
  ...rest
}: BlockComponentModel<TextBlockProps>) {
  const { text, header } = block;

  return (
    <BlockWrapper {...rest} data-tracker-section={SECTION_NAMES.TEXT_BLOCK}>
      <div data-tracker-component='text'>
        <BlockHeaderContent
          {...header}
          classNames={{ children: 'flex-col md:items-start md:text-left' }}
        >
          {text && <RichTextFieldStrapi block={text} />}
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
